<div class="row justify-content-center mb-5">
  <div class="col-12 col-sm-6">
    <div class="d-flex flex-column align-items-center">
      <div class="salon-logo shadow-sm bg-white mb-3"
           [ngStyle]="{ 'background-image': 'url(' + salonDetails?.logoUrl + ')' }"></div>
      <span class="h4 mb-1 text-center fw-bold">
        <a [routerLink]="salonRoute"
           target="_blank">
          {{salonDetails?.name}}
        </a>
      </span>

      <div *ngIf="salonDetails?.reviewsCount > 0"
           class="d-flex align-items-center">
        <span class="salon-grade fw-bold me-1 mb-0 h6">
          {{salonDetails.averageRating.toFixed(1)}}
        </span>
        <app-rating-stars [clickable]="false"
                          [ratingValue]="salonDetails?.averageRating"></app-rating-stars>
        <span class="fw-bold ms-2 mb-0 h6 text-secondary"
              [translate]="'VISIT-REVIEWS.ABOUT-SALON.REVIEWS-COUNT'"
              [translateParams]="{ reviewsCount: salonDetails.reviewsCount }">
        </span>
      </div>

      <div *ngIf="salonDetails?.reviewsCount === 0"
           class="h5 mb-0 text-secondary text-center"
           [translate]="'VISIT-REVIEWS.ABOUT-SALON.NO-REVIEWS-YET'">
      </div>

    </div>
  </div>
</div>
